const sanitizeContactValue = (value) => {
  const normalizedValue = `${value ?? ''}`.trim()

  if (!normalizedValue || normalizedValue === '-') {
    return ''
  }

  return normalizedValue
}

const hasSameValue = (leftValue, rightValue) => {
  return (
    sanitizeContactValue(leftValue).toLowerCase() ===
    sanitizeContactValue(rightValue).toLowerCase()
  )
}

const getContactName = (contact = {}) => {
  const firstName = sanitizeContactValue(contact.firstName)
  const lastName = sanitizeContactValue(contact.lastName)
  const fullName = [firstName, lastName].filter(Boolean).join(' ')

  if (fullName) {
    return fullName
  }

  return sanitizeContactValue(contact.displayName)
}

const getContactCompany = (contact = {}) => {
  return (
    sanitizeContactValue(contact.displayCompanyName) ||
    sanitizeContactValue(contact.companyName)
  )
}

export const getContactIdentityFields = (contact = {}) => {
  const name = getContactName(contact)
  const company = getContactCompany(contact)
  const trade = sanitizeContactValue(contact.jobTitle)
  const email = sanitizeContactValue(contact.email)

  const primary = [name, company, trade, email].find(Boolean) || '-'

  const secondary =
    [company, trade, email].find(
      (candidate) => candidate && !hasSameValue(primary, candidate)
    ) || '-'

  return {
    primary,
    secondary
  }
}
